module.exports = __webpack_public_path__ + "img/dicodingWEB.91dbb7ff.webp";